import CryptoJS from 'crypto-js'
export const encrypt = text => {
  const { hicCryptojsSecret, hicCryptojsIntvector } = useRuntimeConfig().public
  return CryptoJS.AES.encrypt(text, CryptoJS.enc.Utf8.parse(hicCryptojsSecret), { iv: CryptoJS.enc.Utf8.parse(hicCryptojsIntvector) }).toString()
}

export const hash256 = text => {
  return CryptoJS.SHA256(text).toString()
}
